import clsx from "clsx";
export function datePickerTheme(errorMsg) {
  return {
    root: {
      base: "tw-relative",
      input: {
        field: {
          icon: {
            svg: "tw-text-primary-light tw-size-5",
          },
          input: {
            base: clsx(
              errorMsg &&
                "tw-ring-2 tw-border-none tw-outline-none tw-ring-error-light",
              "tw-w-full tw-h-9 tw-border tw-border-border-light tw-text-text-primary-light tw-focus:ring-2 tw-focus:ring-focus tw-focus:border-none "
            ),
          },
        },
      },
    },

    popup: {
      root: {
        base: "tw-absolute tw-top-10 tw-right-0 tw-bottom-0 tw-left-0 tw-z-50 tw-pt-2",
        inline: "tw-relative tw-top-0 tw-z-auto",
        inner:
          "tw-rounded-xl tw-bg-white tw-p-4 tw-shadow-lg dark:tw-bg-gray-700",
      },
      header: {
        base: "",
        title:
          "tw-px-2 tw-py-3 tw-text-center tw-font-semibold tw-text-gray-900 dark:tw-text-white",
        selectors: {
          base: "tw-mb-2 tw-flex tw-justify-between",
          button: {
            base: "tw-rounded-lg tw-bg-white tw-px-5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-gray-900 hover:tw-bg-gray-100 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-gray-200 dark:tw-bg-gray-700 dark:tw-text-white dark:hover:tw-bg-gray-600",
            prev: "",
            next: "",
            view: "",
          },
        },
      },
      view: {
        base: "tw-p-1",
      },
      footer: {
        base: "tw-mt-2 tw-flex tw-space-x-2",
        button: {
          base: "tw-w-full tw-rounded-xl tw-px-5 tw-py-2 tw-text-center tw-text-sm tw-font-medium tw-focus:ring-2 tw-focus:ring-focus",
          today: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
          clear:
            "tw-border tw-border-primary-light tw-bg-white tw-text-primary-light hover:tw-bg-gray-100",
        },
      },
    },
    views: {
      days: {
        header: {
          base: "tw-mb-1 tw-grid tw-grid-cols-7",
          title:
            "tw-h-6 tw-text-center tw-text-sm tw-font-medium tw-leading-6 tw-text-gray-500 dark:tw-text-gray-400",
        },
        items: {
          base: "tw-grid tw-grid-cols-7",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-sm tw-font-semibold tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
      months: {
        items: {
          base: "tw-grid tw-grid-cols-4",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-sm tw-font-semibold tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
      years: {
        items: {
          base: "tw-grid tw-grid-cols-4",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-sm tw-font-semibold tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
      decades: {
        items: {
          base: "tw-grid tw-grid-cols-4",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-sm tw-font-semibold tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
    },
  };
}

export function datePickerInLineTheme(errorMsg) {
  return {
    root: {
      base: "tw-relative",
      input: {
        field: {
          base: "tw-flex tw-items-center tw-border tw-border-border-light tw-rounded-md tw-shadow-sm tw-bg-white focus-within:tw-ring-1 focus-within:tw-ring-blue-600 focus-within:tw-text-blue-600 tw-text-gray-600",
          icon: {
            svg: "tw-size-4 tw-ml-2",
          },
          input: {
            base: clsx(
              errorMsg &&
                "tw-ring-1 tw-border-none tw-outline-none tw-ring-error-light",
              "tw-w-[80%] tw-h-8 focus:tw-ring-0 focus:tw-rounded-md tw-border-none tw-text-text-primary-light tw-p-1 tw-text-sm"
            ),
          },
        },
      },
    },

    popup: {
      root: {
        base: "tw-absolute tw-top-10 tw-right-0 tw-bottom-0 tw-left-0 tw-z-50 tw-pt-2 tw-min-w-[300px]",
        inline: "tw-relative tw-top-0 tw-z-auto",
        inner:
          "tw-rounded-xl tw-bg-white tw-p-4 tw-shadow-lg dark:tw-bg-gray-700",
      },
      header: {
        base: "",
        title: "tw-px-2 tw-py-3 tw-text-center",
        selectors: {
          base: "tw-mb-2 tw-flex tw-justify-between",
          button: {
            base: "tw-rounded-lg tw-bg-white tw-px-2 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-gray-900 hover:tw-bg-gray-100 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-gray-200 dark:tw-bg-gray-700 dark:tw-text-white dark:hover:tw-bg-gray-600",
            prev: "",
            next: "",
            view: "",
          },
        },
      },
      view: {
        base: "tw-p-1",
      },
      footer: {
        base: "tw-mt-2 tw-flex tw-space-x-2",
        button: {
          base: "tw-w-full tw-rounded-xl tw-px-5 tw-py-2 tw-text-center tw-text-xs tw-font-small tw-focus:ring-2 tw-focus:ring-focus",
          today: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
          clear:
            "tw-border tw-border-primary-light tw-bg-white tw-text-primary-light hover:tw-bg-gray-100",
        },
      },
    },
    views: {
      days: {
        header: {
          base: "tw-mb-1 tw-grid tw-grid-cols-7",
          title:
            "tw-h-6 tw-text-center tw-text-xs tw-font-bold tw-text-gray-900 tw-leading-6 tw-text-gray-500 dark:tw-text-gray-400",
        },
        items: {
          base: "tw-grid tw-grid-cols-7",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-xs tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
      months: {
        items: {
          base: "tw-grid tw-grid-cols-4",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-sm tw-font-semibold tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
      years: {
        items: {
          base: "tw-grid tw-grid-cols-4",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-sm tw-font-semibold tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
      decades: {
        items: {
          base: "tw-grid tw-grid-cols-4",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-sm tw-font-semibold tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
    },
  };
}

export function datePickerFormikTheme(errorMsg) {
  return {
    root: {
      base: "tw-relative",
      input: {
        field: {
          base: "tw-flex tw-items-center tw-ring-1 tw-ring-gray-500 tw-rounded-md tw-shadow-sm tw-bg-white focus-within:tw-ring-2 focus-within:tw-ring-blue-600 focus-within:tw-text-blue-600 tw-text-gray-600",
          icon: {
            svg: "tw-size-4 tw-ml-2",
          },
          input: {
            base: clsx(
              errorMsg &&
                "tw-ring-1 tw-border-none tw-outline-none tw-ring-error-light",
              "tw-w-[80%] tw-h-9 focus:tw-ring-0 focus:tw-rounded-md tw-border-none tw-text-text-primary-light tw-p-1 tw-text-sm"
            ),
          },
        },
      },
    },

    popup: {
      root: {
        base: "tw-absolute tw-top-10 tw-right-0 tw-bottom-0 tw-left-0 tw-z-50 tw-pt-2 tw-min-w-[300px]",
        inline: "tw-relative tw-top-0 tw-z-auto",
        inner:
          "tw-rounded-xl tw-bg-white tw-p-4 tw-shadow-lg dark:tw-bg-gray-700",
      },
      header: {
        base: "",
        title: "tw-px-2 tw-py-3 tw-text-center",
        selectors: {
          base: "tw-mb-2 tw-flex tw-justify-between",
          button: {
            base: "tw-rounded-lg tw-bg-white tw-px-2 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-gray-900 hover:tw-bg-gray-100 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-gray-200 dark:tw-bg-gray-700 dark:tw-text-white dark:hover:tw-bg-gray-600",
            prev: "",
            next: "",
            view: "",
          },
        },
      },
      view: {
        base: "tw-p-1",
      },
      footer: {
        base: "tw-mt-2 tw-flex tw-space-x-2",
        button: {
          base: "tw-w-full tw-rounded-xl tw-px-5 tw-py-2 tw-text-center tw-text-xs tw-font-small tw-focus:ring-2 tw-focus:ring-focus",
          today: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
          clear:
            "tw-border tw-border-primary-light tw-bg-white tw-text-primary-light hover:tw-bg-gray-100",
        },
      },
    },
    views: {
      days: {
        header: {
          base: "tw-mb-1 tw-grid tw-grid-cols-7",
          title:
            "tw-h-6 tw-text-center tw-text-xs tw-font-bold tw-text-gray-900 tw-leading-6 tw-text-gray-500 dark:tw-text-gray-400",
        },
        items: {
          base: "tw-grid tw-grid-cols-7",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-xs tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
      months: {
        items: {
          base: "tw-grid tw-grid-cols-4",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-sm tw-font-semibold tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
      years: {
        items: {
          base: "tw-grid tw-grid-cols-4",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-sm tw-font-semibold tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
      decades: {
        items: {
          base: "tw-grid tw-grid-cols-4",
          item: {
            base: "tw-block tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border-0 tw-text-center tw-text-sm tw-font-semibold tw-leading-9 tw-text-gray-900 hover:tw-bg-gray-100 dark:tw-text-white dark:hover:tw-bg-gray-600",
            selected: "tw-bg-primary-light tw-text-white hover:tw-bg-blue-800",
            disabled: "tw-text-gray-500",
          },
        },
      },
    },
  };
}
